import React from "react";
import { Tooltip } from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

export const CustomToolTipCMR = (props) => {
  return (
    <Tooltip className="ml-2 mr-2" title={props.title}>
      <AssignmentOutlinedIcon className="text-black" />
    </Tooltip>
  );
};

export const CustomToolTipDownload = (props) => {
  return (
    <Tooltip className="ml-2 mr-2" title={props.title}>
      <SaveAltRoundedIcon className="text-black" />
    </Tooltip>
  );
};

export const CustomToolTipDelete = (props) => {
  return (
    <Tooltip title={props.title}>
      <DeleteOutlineOutlinedIcon className="text-black" />
    </Tooltip>
  );
};
